/*eslint-disable */
import { FormControl, FormLabel, InputGroup } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Trans } from "react-i18next";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-US";
import it from "date-fns/locale/it";
import es from "date-fns/locale/es";

interface B4FDateProps {
  label?: string;
  isRequired?: boolean;
  value: string;
  placeholder?: string;
  id?: string;
  onBlur?: any;
  onChange: any;
  isDisabled: boolean;
  isInvalid?: boolean;
  visible: boolean;
  onUpdate: any;
  language?: string;
  minDate: any;
}

export const B4FDate: React.FC<B4FDateProps> = (props) => {
  const [startDate, setStartDate] = useState<any>(null);
  const [parsedDate, setParsedDate] = useState<any>("");
  const [language, setLanguage] = useState(props.language);
  const [locale, setLocale] = useState("");
  const [dateFormat, setDateFormat] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [touched, setTouched] = useState(false);
  const [highlight, setHighlight] = useState(false);

  function isDate(s: any) {
    if (isNaN(s) && !isNaN(Date.parse(s))) return true;
    else return false;
  }

  useEffect(() => {
    if (isDate(props.value)) {
      setStartDate(new Date(Date.parse(props.value)));
      setParsedDate(props.value);
    }
    if (props.isRequired) {
      if (!isDate(parsedDate)) {
        setHighlight(true);
      } else {
        setHighlight(false);
      }
    } else {
      setHighlight(false);
    }
  }, [props.value]);

  useEffect(() => {
    setLanguage(props.language);
    if (language === "ENGLIGH") {
      registerLocale("en", en);
      setLocale("en");
      setDateFormat("MM/dd/yyyy");
    } else {
      if (language === "ITALIAN") {
        registerLocale("it", it);
        setLocale("it");
      } else if (language === "SPANISH") {
        registerLocale("es", es);
        setLocale("es");
      } else {
        registerLocale("fr", fr);
        setLocale("fr");
      }
      setDateFormat("dd/MM/yyyy");
    }
  }, [props.language]);

  function handleChange(date: any) {
    if (date !== null) {
      let newParsedDate =
        date.getFullYear() +
        "-" +
        (date.getMonth() > 8
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        "-" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate());

      setParsedDate(newParsedDate);
      setStartDate(date);
      setTouched(true);

      props.onChange({
        target: {
          id: props.id,
          value: newParsedDate,
        },
        id: props.id,
        type: "date",
        value: newParsedDate,
        valid: isDate(newParsedDate),
      });

      props.onUpdate({
        target: {
          id: props.id,
          value: newParsedDate,
        },
        id: props.id,
        type: "date",
        value: newParsedDate,
        valid: isDate(newParsedDate),
      });
    }
  }
  if (props.visible) {
    return (
      <>
        <FormControl
          isRequired={props.isRequired}
          isDisabled={props.isDisabled}
        >
          <FormLabel>
            <Trans>{props.label}</Trans>
          </FormLabel>
          <InputGroup>
            <DatePicker
              wrapperClassName="datePicker"
              disabled={props.isDisabled}
              selected={startDate}
              onChange={handleChange}
              dateFormat={dateFormat}
              minDate={props.minDate}
              locale={locale}
              showYearDropdown
              className={!isDate(parsedDate) ? "invalid" : "valid"}
              onChangeRaw={(e) => e.preventDefault()}
            />
          </InputGroup>
        </FormControl>
      </>
    );
  } else {
    return null;
  }
};
